import { axios } from '@/lib/axios';
import { Group } from '@/features/Translations/types';

export const getGroup = (id: string): Promise<Group> => {
    return axios.get(`/api/admin/site_translation/group/${id}`);
};
